<mat-toolbar [class.boticario]="isBoticario" [class.reduce-height]="reduceHeight" [style.background-color]="bgColor">
  <button *ngIf="isClickable" mat-icon-button (click)="goToStart(); onBackClick()">
    <mat-icon>{{ icon }}</mat-icon>
  </button>
  <mat-icon *ngIf="!isClickable">{{ icon }}</mat-icon>
  <span class="title">{{ text }}</span>
</mat-toolbar>
